import React from 'react';
import PropTypes from 'prop-types';

import VrmChecker from '../VrmChecker/VrmChecker';
import VrmUlezChecker from '../VrmUlezChecker/VrmUlezChecker';

const VrmCheckerFooter = ({ useUlezVrmChecker, ...props }) => (
  useUlezVrmChecker
    ? <VrmUlezChecker hideErrors inFooter />
    : <VrmChecker {...props} />
);

VrmCheckerFooter.defaultProps = {
  useUlezVrmChecker: false,
};

VrmCheckerFooter.propTypes = {
  useUlezVrmChecker: PropTypes.bool,
};

export default VrmCheckerFooter;
